import { Popover as OriginalPopover } from 'antd';
import './Antd-styles.less';
import * as React from 'react';
import style from './index.module.scss';

export const Popover: any = (props: any): React.ReactNode => {
  return <OriginalPopover overlayClassName={style.popup} {...props} />;
};
